import * as React from 'react';

import PaymentsTableBody from './PaymentsTableBody';

const GetPaymentsInfo = (props) => {
  if (undefined !== props.paymentsInfoData.data && props.paymentsInfoData.data.length) {
    return props.paymentsInfoData.data.map((item, key) => {
      return(
        <PaymentsTableBody
          key={key}
          date={item.date}
          type={item.type}
          paymentSystem={item.payment_system}
          sum={item.sum} />
      );
    });
  } else {
    return null;
  }
};

export default GetPaymentsInfo;
